import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { updateData, setCopyData } from "../../redux/dataSlice";
import { getDropdownsData } from "../../functions/filter/getDropdownsData";
import { setIsFiltered, setFilteredData } from "../../redux/isTableFilterSlice";
import { betterFilter } from "../../functions/filter/betterFilter";
import DesktopFIlterView from "./DesktopFilterUi/DesktopFIlterView";
import MobileFIlterView from "./mobileFilterUi/MobileFIlterView";
import { deleteFilterKeysIfDataChecked } from "../../functions/filter/deleteFilterKeysIfDataChecked";

const FilterData = ({
  categories,
  isActionSucceed,
  checkResponseDataId,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const copyData = useSelector((state) => state.data.copyData);
  const data = useSelector((state) => state.data.data);
  const isFiltered = useSelector((state) => state.isTableFilter.isFiltered);
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab
  );
  const [selectedItems, setSelectedItems] = useState({});
  const categoryAndOptionList = getDropdownsData(
    categories,
    copyData,
    location
  );
  // Applying filter
  const filteredData = betterFilter(copyData, selectedItems);

  const setFilter = () => {
    const isEmpty = Object.keys(selectedItems).length === 0;
    dispatch(updateData(isEmpty ? copyData : filteredData));
    dispatch(setIsFiltered(!isEmpty));
    dispatch(setFilteredData(isEmpty ? [] : filteredData));
  };

  useEffect(() => {
    if (isActionSucceed) {
      const updateOnDataCheck = (array) =>
        array.filter((item) => !checkResponseDataId.includes(item.id));
      const updatedData = updateOnDataCheck(data);
      const updatedCopyData = updateOnDataCheck(copyData);
      dispatch(setCopyData(updatedCopyData));
      dispatch(updateData(updatedData));
      if (isFiltered) {
        const deletedFilterKeysIfDataChecked = deleteFilterKeysIfDataChecked(
          updatedCopyData,
          selectedItems
        );
        setSelectedItems(deletedFilterKeysIfDataChecked);
        const againFilter = betterFilter(
          updatedCopyData,
          deletedFilterKeysIfDataChecked
        );
        dispatch(updateData(againFilter));
        dispatch(setFilteredData(againFilter));
      }
    }
  }, [isActionSucceed]);

  useEffect(() => {
    setSelectedItems({});
    dispatch(setIsFiltered(false));
    dispatch(setFilteredData([]));
    if (activeHeaderTab === "Custom Date") {
      dispatch(updateData(copyData));
      document.querySelectorAll('input[type="checkbox"]');
      var checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
    }
  }, [activeHeaderTab]);

  return (
    <>
      <DesktopFIlterView
        categoryAndOptionList={categoryAndOptionList}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        handleFilter={setFilter}
        originalData={copyData}
      />
      <MobileFIlterView
        categoryAndOptionList={categoryAndOptionList}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        handleFilter={setFilter}
        originalData={copyData}
      />
    </>
  );
};
export default FilterData;
